import { t } from '../../localization';
import React, { Component } from 'react';
import { EventName } from '../../services/dystirWebClientService';
import MatchDate from '../../extentions/matchDate';
import { format } from 'react-string-format';
import { GiSoccerBall } from "react-icons/gi";
import { FaStar } from "react-icons/fa";

export class CommentaryEventView extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const match = this.props.match;
        const event = this.props.event;
        
        let contents =
            <table className="summary_main_table">
                <tbody>
                    <tr>
                        <td className={"summary_event " + (event.eventTeam == match.homeTeam ? "visible" : "invisible")}>
                        {
                            event.eventName == EventName.GOAL &&
                            <>
                                <GiSoccerBall className="goal_icon" />
                                <span style={{ margin: "0 5px" }}>{t('Goal')}</span>
                            </> ||
                            event.eventName == EventName.OWNGOAL &&
                            <>
                                <GiSoccerBall className="owngoal_icon"/>
                                <span style={{ margin: "0 5px" }}>{t('OwnGoal')}</span>
                            </> ||
                            event.eventName == EventName.PENALTYSCORED &&
                            <>
                                <GiSoccerBall className="goal_icon" />
                                <span style={{ margin: "0 5px" }}>{t('PenaltyScored')}</span>
                            </> ||
                            event.eventName == EventName.PENALTYMISSED &&
                                <span className="penalty_missed">{t('PenaltyMissed')}</span> ||
                            event.eventName == EventName.BIGCHANCE &&
                                <span className="big_chance">{t('BigChance')}</span> ||
                            event.eventName == EventName.PENALTY &&
                                <span className="big_chance">{t('Penalty')}</span> ||
                            event.eventName == EventName.YELLOW &&
                                <span className="yellow_card"></span> ||
                            event.eventName == EventName.RED &&
                                <span className="red_card"></span> ||
                            event.eventName == EventName.SUBSTITUTION &&
                            <>
                                <span className="sub_in">&#9650;</span>
                                <span className="sub_out">&#9660;</span>
                            </> ||
                            event.eventName == EventName.ASSIST &&
                                <div className="big_chance">{t('Assists')}</div> ||
                            event.eventName == EventName.CORNER &&
                                <div className="secondary_event">{t('Corner')}</div> ||
                            event.eventName == EventName.ONTARGET &&
                                <div className="secondary_event">{t('OnTarget')}</div> ||
                            event.eventName == EventName.OFFTARGET &&
                                <div className="secondary_event">{t('OffTarget')}</div> ||
                            event.eventName == EventName.BLOCKEDSHOT &&
                                <div className="secondary_event">{t('BlockedShot')}</div> ||
                            event.eventName == EventName.PLAYEROFTHEMATCH &&
                                <FaStar style={{ color: "gold" }} />
                        }
                        </td>

                        <td className="minutes_summary">
                        {
                            event.eventName == EventName.PLAYEROFTHEMATCH &&
                                <div className="player_of_the_match">{t('PlayerOfTheMatch')}</div> ||
                                <div>
                                {
                                    this.getEventMinute(event)
                                }
                                </div>
                        }
                        </td>

                        <td className={"summary_event " + (event.eventTeam == match.awayTeam ? "visible" : "invisible")}>
                        {
                            event.eventName == EventName.GOAL &&
                            <>
                                <span style={{ margin: "0 5px" }}>{t('Goal')}</span>
                                <GiSoccerBall className="goal_icon" />
                            </> ||
                            event.eventName == EventName.OWNGOAL &&
                            <>
                                <span style={{ margin: "0 5px" }}>{t('OwnGoal')}</span>
                                <GiSoccerBall className="owngoal_icon" />
                            </> ||
                            event.eventName == EventName.PENALTYSCORED &&
                            <>
                                <span style={{ margin: "0 5px" }}>{t('PenaltyScored')}</span>
                                <GiSoccerBall className="goal_icon" />
                            </> ||
                            event.eventName == EventName.PENALTYMISSED &&
                                <span className="penalty_missed">{t('PenaltyMissed')}</span> ||
                            event.eventName == EventName.BIGCHANCE &&
                                <span className="big_chance">{t('BigChance')}</span> ||
                            event.eventName == EventName.PENALTY &&
                                <span className="big_chance">{t('Penalty')}</span> ||
                            event.eventName == EventName.YELLOW &&
                                <span className="yellow_card"></span> ||
                            event.eventName == EventName.RED &&
                                <span className="red_card"></span> ||
                            event.eventName == EventName.SUBSTITUTION &&
                            <>
                                <span className="sub_out">&#9660;</span>
                                <span className="sub_in">&#9650;</span>
                            </> ||
                            event.eventName == EventName.ASSIST &&
                                <div className="big_chance">{t('Assists')}</div> ||
                            event.eventName == EventName.CORNER &&
                                <div className="secondary_event">{t('Corner')}</div> ||
                            event.eventName == EventName.ONTARGET &&
                                <div className="secondary_event">{t('OnTarget')}</div> ||
                            event.eventName == EventName.OFFTARGET &&
                                <div className="secondary_event">{t('OffTarget')}</div> ||
                            event.eventName == EventName.BLOCKEDSHOT &&
                                <div className="secondary_event">{t('BlockedShot')}</div> ||
                            event.eventName == EventName.PLAYEROFTHEMATCH &&
                                <FaStar style={{ color: "gold" }} />
                        }
                        </td>
                    </tr>
                </tbody>
            </table>
        return contents
    }

    getEventMinute(event) {
        switch (event.eventPeriodId) {
            case 1:
                return "";
            case 3:
                return "46'";
            case 5:
                return "91'";
            case 7:
                return "106'";
            case 9:
                return "121'";
            case 10:
                return "120'";
            case 11:
            case 12:
            case 13:
                return "";
            default:
                return event.eventMinute;
        }
    }
}
